import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { ARTICLES } from "@/data/articles";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";

export default function Blog() {
  useEffect(() => { document.title = "Useful Articles — Step Zone"; }, []);

  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-24 lg:px-8" data-testid="blog-page">
        <div className="max-w-2xl">
          <p className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            Useful Articles
          </p>
          <h1 className="mt-3 font-heading text-4xl font-bold tracking-tighter text-foreground sm:text-5xl">
            Practical money reads
          </h1>
          <p className="mt-4 font-body text-base leading-relaxed text-muted-foreground md:text-lg">
            Short, no-fluff guides on lowering expenses, financing, credit,
            savings, and insurance — to help you take your next step with
            confidence.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: (i % 3) * 0.05 }}
            >
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group flex h-full flex-col rounded-2xl border-2 border-border bg-card p-6 transition-colors hover:border-primary"
              >
                <div className="flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <BookOpen className="h-4.5 w-4.5" />
                  </span>
                  <span className="font-body text-xs font-semibold uppercase tracking-wide text-muted-foreground">{a.category}</span>
                </div>
                <h2 className="mt-4 font-heading text-lg font-semibold tracking-tight text-foreground group-hover:text-primary">
                  {a.title}
                </h2>
                <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-muted-foreground">{a.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 font-heading text-sm font-semibold text-primary">
                  Read <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
